export default __webpack_public_path__ + "static/hw_ff_leds-088bd30e50295dda42e1098f64d27855.png";